var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualifiedG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41 35v-3a6 6 0 0 0-6-6h-6a6 6 0 0 0-6 6v3s1 2 9 2 9-2 9-2z",
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 5,
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 32v3s-1 2-9 2a31.037 31.037 0 0 1-5.07-.36A19.821 19.821 0 0 0 52 26h5a6 6 0 0 1 6 6zM59 20a5 5 0 0 1-5 5 5.073 5.073 0 0 1-2.06-.44 19.68 19.68 0 0 0-2.02-7.45A5 5 0 0 1 59 20zM15.07 36.64A31.037 31.037 0 0 1 10 37c-8 0-9-2-9-2v-3a6 6 0 0 1 6-6h5a19.821 19.821 0 0 0 3.07 10.64zM14.08 17.11a19.68 19.68 0 0 0-2.02 7.45A5.073 5.073 0 0 1 10 25a5 5 0 1 1 4.08-7.89z",
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8a18 18 0 1 0 18 18A18 18 0 0 0 32 8zm0 34a16 16 0 1 1 16-16 16 16 0 0 1-16 16z",
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.284 38.708 1.414-1.414 5 5-1.415 1.413z",
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.99 45.001 4-4L61.988 52l-4 4z",
    fill: "#6c9381",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiedG);
export default __webpack_public_path__ + "static/media/qualified-g.a2df2434d8f6405d6eb275b99b040cfd.svg";
export { ForwardRef as ReactComponent };